import { render, staticRenderFns } from "./yc_broadcast.vue?vue&type=template&id=96facb1a&"
import script from "./yc_broadcast.vue?vue&type=script&lang=js&"
export * from "./yc_broadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports